import * as React from 'react';
import matchSorter from 'match-sorter';
import Spinner from '@clearkit/icons/indicators/Spinner';
import NoResults from '@clearkit/icons/glyphs/NoResults';

import { ItemBase } from './types';

// Shamelessly stolen from
// https://github.com/segmentio/evergreen/blob/master/src/avatar/src/utils/getInitials.js
export const getInitials = (name: string) => {
  return name
    .replace(/\s+/, ' ')
    .split(' ')
    .slice(0, 2)
    .map(v => v && v[0].toUpperCase())
    .join('');
};

export function defaultItemRenderer<T extends ItemBase>(selected: T) {
  return selected.label;
}

export function defaultEmptyState(inputValue: string) {
  return (
    <span className="ck-option-hint">
      <span className="ck-option-hint-accessory">
        <NoResults width={18} height={18} />
      </span>
      <span>
        No results for <b>'{inputValue}'</b>
      </span>
    </span>
  );
}

export function defaultAttributeSelectorEmptyState() {
  return (
    <span className="ck-option-hint">
      <span className="ck-option-hint-accessory">
        <NoResults width={18} height={18} />
      </span>
      <span>No attributes found</span>
    </span>
  );
}

export function defaultOptionFilterFunc<T>(items: T[], inputValue: string) {
  return matchSorter(items, inputValue, { keys: ['value', 'label'] });
}

export function defaultInitialState() {
  return <span className="ck-option-hint">Start typing...</span>;
}

export function defaultLoadingState() {
  return (
    <span className="ck-option-hint">
      <span className="ck-option-hint-accessory">
        <Spinner height={18} width={18} />
      </span>
      <span>Searching...</span>
    </span>
  );
}
